import './devConsoleSilence';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './utils/env'; // Validate environment variables
import './i18n'; // Initialize i18n
import './index.css';
import App from './App.tsx';
import { features } from './services/features';

if (import.meta.env.DEV) {
  (window as any).features = features;
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
